import React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';

const Agree = (props) => {
	const {
		url,
		text,
		urlText,
		termsLabel,
		termsUrl,
		termsUrlText,
		checkedValue,
		uncheckedValue,
		value,
		onChange,
		name,
		...otherProps
	} = props;

	const handleAgreeChange = (e) => {
		const value = e.target.checked ? (checkedValue || true) : (uncheckedValue || false);
		onChange({ target: { name, value } });
	};

	return (
		<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
			<Checkbox checked={value} onChange={(e) => handleAgreeChange(e)} sx={{ flexGrow: 0 }} />
			<Typography variant='body' sx={{ a: { color: 'rgba(0, 206, 124, 1)' } }}>
				{termsLabel || text} <Link href={termsUrl || url} target='_blank'> {termsUrlText || urlText}</Link>
			</Typography>
		</div>
	);
};

Agree.type = 'Agree';

export default Agree;
